angular.
module("dx.webapp.answer").
controller("DxSingleMultiChoiceAnswerController", function SingleMultiChoiceAnswerController(
	$scope,

	DX_QUESTION_TYPE,
	dxSession,
	RoleTypeEnum,
	DX_QUESTION_GRADING_TYPE
) {
	"use strict";

	var self = this;

	self.$scope = $scope;
	self.DX_QUESTION_TYPE = DX_QUESTION_TYPE;
	self.hasTeacherRole = dxSession.getRole().roleType !== RoleTypeEnum.STUDENT;

	switch ($scope.gradingType) {
		case DX_QUESTION_GRADING_TYPE.ALL_OR_NOTHING:
		case DX_QUESTION_GRADING_TYPE.RIGHT_MINUS_WRONG:
		case DX_QUESTION_GRADING_TYPE.POINTS_PER_RESPONSE:
			self.validGradingType = true;
			break;
		default:
			self.validGradingType = false;
	}

	self.isChecked = function isChecked(alternative) {
		if (!this.$scope.answer) {
			return false;
		}

		if (this.$scope.answer.data instanceof Array) {
			return this.$scope.answer.data.indexOf(alternative.id) > -1;
		}
		return alternative.id === this.$scope.answer.data;
	};

	self.getAlternativeResultLocaleKey = function getAlternativeResultLocaleKey(alternative) {
		if (angular.isUndefined(this.$scope.showCorrectness) || this.$scope.showCorrectness === null) {
			this.$scope.showCorrectness = true;
		}

		if (this.$scope.showCorrectness && this.isChecked(alternative)) {
			if (alternative.right) {
				return "CorrectAnswer";
			}
			return "IncorrectAnswer";
		}

		if (alternative.right && this.$scope.showCorrectness) {
			return "CorrectAlternative";
		}

		return "";
	};
});
